export const apiKeyKeys = {
  all: (storeId: string) => ['stores', storeId, 'api-keys'] as const,
  list: (storeId: string) => [...apiKeyKeys.all(storeId), 'list'] as const,
};
